import React from 'react'
function Gifcomponent({src}) {
  return (
    <div className='main-wrapper'>
        <img src={src} alt="Loader" className='img-fluid'/>
    </div>
  )
}

export default Gifcomponent